import * as z from "zod";

/** Where to send the merchant: hosted onboarding, or their own Stripe dashboard. */
export const ProviderConnect = z.object({ url: z.string() });
export type ProviderConnect = z.output<typeof ProviderConnect>;

/** A single-use Stripe Terminal SDK connection token. */
export const TerminalConnectionToken = z.object({
  secret: z.string(),
  /** The store's connected Stripe account (acct_…). */
  accountId: z.string(),
  /** The Terminal location the token is scoped to; null when no branch was named or it is not set up yet. */
  terminalLocationId: z.string().nullable(),
});
export type TerminalConnectionToken = z.output<typeof TerminalConnectionToken>;

/** Everything a Terminal SDK needs to collect one in-person payment for a customer cart. */
export const TerminalCheckout = z.object({
  checkoutId: z.string(),
  customerCartId: z.string(),
  accountId: z.string(),
  connectionToken: z.string(),
  paymentIntentId: z.string(),
  paymentIntentClientSecret: z.string(),
  /** Minor units: subtotal, tax and both fees. */
  amountTotal: z.number(),
  subtotalAmount: z.number(),
  taxAmount: z.number(),
  /** HobbyScan technology fee the customer pays; zero when switched off. */
  platformFeeAmount: z.number(),
  /** Card processing fee the customer pays at Stripe's in-person rate; shown apart from the technology fee. */
  processingFeeAmount: z.number(),
  currency: z.string(),
});
export type TerminalCheckout = z.output<typeof TerminalCheckout>;
